import React from 'react';
import { FunctionField } from 'react-admin';
import Chip from '@material-ui/core/Chip';

const STATUS_CONFIG = {
  0: {
    label: 'EM ANDAMENTO',
    borderColor: '#2196F3',
    color: '#2196F3',
  },
  1: {
    label: 'FINALIZADO',
    borderColor: '#2e7d32',
    color: '#2e7d32',
  },
  2: {
    label: 'FALHA',
    borderColor: '#c62828',
    color: '#c62828',
  },
};

const PanelStatusBadge = (props) => (
  <FunctionField
    label="Status"
    render={(record) => {
      const statusId = record?.statusPanel?.id ?? record?.statusPanelId;
      const config = STATUS_CONFIG[statusId] || STATUS_CONFIG[0];
      return (
        <Chip
          label={config.label}
          size="small"
          variant="outlined"
          style={{
            backgroundColor: '#fff',
            color: config.color,
            borderColor: config.borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 16,
            fontWeight: 500,
            fontSize: '0.75rem',
          }}
        />
      );
    }}
    {...props}
  />
);

export default PanelStatusBadge;
